export default class AuthoritiesManageOfEvent {
    constructor(publicAuthoritiesContacted, numberAuthorities, authoritiespages) {
        this.publicAuthoritiesContacted = publicAuthoritiesContacted;
        this.numberAuthorities = numberAuthorities;
        this.authoritiespages = authoritiespages;
    }
}